import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, TextField } from '@material-ui/core'
import { Autocomplete as AutocompleteMui } from '@material-ui/lab'

const Autocomplete = ({ loading, textFieldProps, InputProps, ...rest }) => {
  return (
    <AutocompleteMui
      {...rest}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          InputProps={{
            ...params.InputProps,
            ...InputProps,
            endAdornment: (
              <>
                {params?.InputProps?.endAdornment}
                {InputProps?.endAdornment}
                {loading && <CircularProgress color="primary" size={20} />}
              </>
            ),
          }}
        />
      )}
      loading={loading}
    />
  )
}

Autocomplete.propTypes = {
  loading: PropTypes.bool,
  textFieldProps: PropTypes.object,
  InputProps: PropTypes.object,
}

export default Autocomplete
